import { MatPaginatorIntl } from '@angular/material/paginator';
import { MsalBroadcastService, MsalGuard, MsalService } from '@azure/msal-angular';
import { environment } from '@env/environment';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore } from '@ngrx/router-store';
import { ActionReducer, provideState, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { FORMLY_CONFIG } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { localStorageSync } from 'ngrx-store-localstorage';
import { CustomMatPaginatorIntl, registerTranslateExtension } from './custom-translators';
import { ConsoleLogService, LogService } from './logging';
import * as coreStore from './store';

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [{ projects: ['selectedProjectId'] }],
    rehydrate: true,
  })(reducer);
}

export const coreProviders = [
  { provide: LogService, useClass: ConsoleLogService },
  {
    provide: MatPaginatorIntl,
    useClass: CustomMatPaginatorIntl,
  },
  {
    provide: FORMLY_CONFIG,
    multi: true,
    useFactory: registerTranslateExtension,
    deps: [TranslateService],
  },
  MsalGuard,
  MsalBroadcastService,
  MsalService,
  provideStore(undefined, { metaReducers: [localStorageSyncReducer] }),
  provideState(coreStore.coreFeatureName, coreStore.coreReducers),
  provideEffects([...coreStore.coreEffects]),
  provideStoreDevtools({
    maxAge: 25,
    logOnly: environment.production,
    connectInZone: true,
  }),
  provideRouterStore(),
];
